import { PaymentBrandLogos } from '../../billing/PaymentBrandLogos.jsx';
import { PaymentTrustPanel } from '../../billing/PaymentTrustPanel.jsx';

/** Ana sayfa alt bandı — iletişim, logolar, güvenlik (SLOT-LANDING-CTA) */
export function LandingFooterBand({
  bankBadges = [],
  siteSslType = 'dv',
  companyAddress = '',
}) {
  return (
    <footer className="pp-landing-cta-band" role="contentinfo">
      <div className="pp-landing-cta-band__stack">
        <div className="pp-landing-cta-band__contact">
          <h2>Sorularınız mı var?</h2>
          <p>Paketler ve kurumsal çözümler için bizimle iletişime geçin.</p>
          <div className="pp-landing-cta-band__buttons">
            <a className="pp-landing-hero__cta" href="mailto:info@proparcel.com">
              <i className="fas fa-envelope" aria-hidden="true" />
              {' '}
              info@proparcel.com
            </a>
          </div>
          <nav className="pp-landing-cta-band__legal" aria-label="Hukuki bağlantılar">
            <a className="pp-landing-cta-band__legal-lead" href="/hukuki/">Hukuki metinler</a>
            <span aria-hidden="true"> · </span>
            <a href="/hukuki/gizlilik-politikasi/">Gizlilik</a>
            <span aria-hidden="true"> · </span>
            <a href="/hukuki/kvkk/">KVKK</a>
            <span aria-hidden="true"> · </span>
            <a href="/hukuki/mesafeli-satis-sozlesmesi/">Mesafeli satış</a>
          </nav>
          <div className="pp-landing-cta-band__payment">
            <PaymentBrandLogos surface="dark" banks={bankBadges} />
          </div>
          <PaymentTrustPanel surface="dark" sslType={siteSslType} />
          {companyAddress ? (
            <p className="pp-landing-cta-band__address">{companyAddress}</p>
          ) : null}
        </div>
      </div>
    </footer>
  );
}
